<ng-container *ngIf="user">
  <div
    class="list-item-header"
    [attr.data-cy]="'user-list-item-id-' + user._id">
    <div class="header-left">
      <mat-checkbox
        (click)="$event.stopPropagation()"
        [(ngModel)]="inviteCheckboxEnabled"
        (ngModelChange)="onSelectionChange()"
        class="employee-checkbox"
        data-cy="invite-checkbox"></mat-checkbox>
      <div>
        <div class="employee-name">
          <div class="first-name">
            {{
              loggedInCustomer?.prioritizeEmployeeLastName
                ? user?.lastName
                : user?.firstName
            }}
          </div>
          <div class="last-name">
            {{
              loggedInCustomer?.prioritizeEmployeeLastName
                ? user?.firstName
                : user?.lastName
            }}
          </div>
        </div>
        <div
          class="employee-customer"
          *ngIf="user.originCustomer">
          Via
          {{
            user.originCustomer.displayName +
              (user.originCustomer.tariff
                ? " /" + user.originCustomer.tariff
                : "")
          }}
        </div>
      </div>
    </div>
    <div class="header-right">
      <div
        *ngIf="user?.hasBlacklistedJobDepartment"
        class="department-blacklist-warning text-error"
        data-cy="department-blacklist-warning"
        [matTooltip]="'departmentDeselectedByPooler' | i18n"
        matTooltipPosition="above">
        <mat-icon
          class="size-20 text-icon-error department-blacklist-warning-icon"
          svgIcon="alert-outline"></mat-icon>
        <span class="d-none d-md-block">
          {{ "departmentDeselected" | i18n }}
        </span>
        <span class="d-block d-md-none">
          {{ "department" | i18n }}
        </span>
      </div>
      <app-previous-jobs-logs
        [user]="user"
        [departmentId]="departmentId ?? ''">
      </app-previous-jobs-logs>
      <availability-percentage-bar
        *ngIf="user?._id && fromDate && toDate"
        [user]="user"
        [fromDate]="fromDate"
        [toDate]="toDate"
        [availabilityPercentage]="
          user.matchPercentage || 0
        "></availability-percentage-bar>
    </div>
  </div>
  <div
    class="collapse-wrapper"
    [class.collapsed]="detailsCollapsed">
    <div class="collapse-child">
      <div>
        <employment-mini-availability-match
          *ngIf="!detailsCollapsed && fromDate && toDate"
          [user]="user"
          [fromDate]="fromDate"
          [toDate]="toDate"
          [availabilityPercentage]="
            user.matchPercentage || 0
          "></employment-mini-availability-match>
        <user-list-item-details
          class="user-details mt-1"
          [user]="user"></user-list-item-details>
      </div>
    </div>
  </div>
</ng-container>
